<template>
  <v-container fill-height class="d-flex flex-column justify-space-between pa-0">
    <v-carousel
      v-model="slide"
      hide-delimiter-background
      height="100vh"
      show-arrows="hover"
      cycle
      class="home-carousel"
    >
      <v-carousel-item
        v-for="(feature, i) in features"
        :key="i"
        class="d-flex flex-column align-center justify-center px-6"
      >
        <v-img :src="feature.image" contain height="250"></v-img>
        <h3 class="text-h5 font-weight-bold text-center mt-6 mb-2">
          {{ feature.title }}
        </h3>
        <p class="text-body-1 text-center mb-10">{{ feature.description }}</p>
      </v-carousel-item>
    </v-carousel>

    <v-row justify="center" class="mt-2 mb-4">
      <v-btn
        color="deep-purple accent-4"
        class="btn-next rounded-circle"
        fab
        @click="goNext"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      features: [
        {
          title: "Qarzlarni SMS orqali yig‘ish",
          description:
            "Qarzdor mijozlarga SMS yuborish orqali ogohlantirish va qarzni undirish",
          image:
            "https://cdn.dribbble.com/users/1787323/screenshots/14152175/media/dfcae083abb40a376ddf209b6dfb0fd9.png",
        },
        {
          title: "Onlayn Monitoring",
          description: "Jarayonlarni real vaqt rejimida kuzatish imkoniyati",
          image:
            "https://cdn.dribbble.com/users/1200232/screenshots/16141321/media/e9a55dd24694969499463e65e10be7ad.png",
        },
        {
          title: "Profilingizni sozlang",
          description: "Foydalanuvchi ma'lumotlarini yangilang va boshqaring",
          image:
            "https://cdn.dribbble.com/users/291221/screenshots/5351753/profile.png",
        },
      ],
    };
  },
  methods: {
    goNext() {
      if (this.slide < this.features.length - 1) {
        this.slide++;
      } else {
        this.$router.push({ name: "profile" });
      }
    },
  },
};
</script>

<style scoped>
.home-carousel {
  background-color: #fafafa;
}
.btn-next {
  box-shadow: 0 10px 20px rgba(138, 43, 226, 0.3);
  width: 56px;
  height: 56px;
}
h3 {
  color: #333;
}
p {
  color: #666;
  max-width: 300px;
}
</style>
